export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtBarva';
export const NAME = 'Barva';
